module.exports = __webpack_public_path__ + "media/damages/car-rl@2x-494441cd.png";